<nb-card [nbSpinner]="loading()">
  <nb-card-body>
    <div class="info-container">
      <div class="info-section">
        <div class="info-section-header">
          <nb-icon icon="building" pack="fas"></nb-icon>
          Gebäude
        </div>
        <div class="info-section-body">
          <div class="info-item">
            <nb-icon icon="building" pack="fas"></nb-icon>
            {{ buildingCount() }} Gebäude
          </div>
          <div class="info-item">
            <nb-icon icon="ruler" pack="fas"></nb-icon>
            {{ roundArea(totalArea()) }} m²
          </div>
        </div>
      </div>
      @if (repairTasksVisible()) {
        <div class="info-section">
          <div class="info-section-header">
            <nb-icon icon="tools" pack="fas"></nb-icon>
            Reparaturaufträge
          </div>
          <wr-repair-task-chart [filter]="filter"></wr-repair-task-chart>
        </div>
      }
      <div class="info-section">
        <div class="info-section-header">
          <nb-icon icon="clipboard-check" pack="fas"></nb-icon>
          Rundgänge
        </div>
        <wr-inspection-chart [filter]="filter"></wr-inspection-chart>
      </div>
    </div>
  </nb-card-body>
</nb-card>
